export const THEMES = {
  professional: {
    name: 'Profissional',
    icon: 'i-lucide-briefcase-business',
    story: 'Resultados consistentes, reconhecimento merecido.',
  },
  adventure: {
    name: 'Aventura RPG',
    icon: 'i-lucide-swords',
    hero: 84,
    companion: 99,
    accent: '#a78bfa',
    sky: '#20193b',
    ground: '#453667',
    story: 'Cada atendimento é uma nova missão.',
  },
  board: {
    name: 'Tabuleiro',
    icon: 'i-lucide-dices',
    hero: 88,
    companion: 100,
    accent: '#38bdf8',
    sky: '#122b42',
    ground: '#27546d',
    story: 'Avance uma casa a cada conquista.',
  },
  zombie: {
    name: 'Sobrevivência',
    icon: 'i-lucide-flame',
    hero: 96,
    companion: 97,
    accent: '#a3e635',
    sky: '#152923',
    ground: '#345047',
    story: 'Sua equipe unida vence qualquer desafio.',
  },
  royal: {
    name: 'Reino encantado',
    icon: 'i-lucide-crown',
    hero: 85,
    companion: 87,
    accent: '#f9a8d4',
    sky: '#382241',
    ground: '#734d79',
    story: 'Construa um reino de boas experiências.',
  },
};
export const sprite = number =>
  `/gamification/tiny-dungeon/tile_${String(number).padStart(4, '0')}.png`;
